import { loadStripe, type Stripe } from '@stripe/stripe-js';

/**
 * Lazy-load Stripe.js using the publishable key from Vite env.
 *
 * Returns the same Promise on every call (Stripe-recommended singleton pattern)
 * so we only load the SDK script once, regardless of how many components mount it.
 *
 * Returns `null` when the key isn't configured — callers must guard against this
 * before mounting <Elements>.
 */
let cached: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (cached !== null) return cached;
  const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined;
  if (!key) {
    cached = Promise.resolve(null);
    return cached;
  }
  cached = loadStripe(key);
  return cached;
}
